import { makeChartComp } from '../../util/makeChartComp';
var SunburstChart = makeChartComp('Sunburst');
export default SunburstChart;
